import { create } from 'zustand'

export const useZustand = create((set) => ({
  auth: null,
  users: [],
  companies: [],
  banks: [],
  bankAccounts: [],
  indentures: [],
  paymentPlans: [],
  sources: [],
  objects: [],
  rights: [],
  accessGroups: [],
  loanContracts: [],
  interCompanyFinances: [],
  companyTypes: [],
  chartelCapitalTransactions: [],
  accounts: [],
  moneyFlowReasons: [],
  documentSets: [],
  setRightsState: (value) => set({ rights: value }),
  setAccessGroupState: (value) => set({ accessGroups: value }),
  setObjectsState: (value) => set({ objects: value }),
  setAuth: (value) => set({ auth: value }),
  setUserState: (value) => set({ users: value }),
  setCompanyState: (value) => set({ companies: value }),
  setBankState: (value) => set({ banks: value }),
  setBankAccountState: (value) => set({ bankAccounts: value }),
  setIndentureState: (value) => set({ indentures: value }),
  setPaymentPlanState: (value) => set({ paymentPlans: value }),
  setSourceState: (value) => set({ sources: value }),
  setLoanContractState: (value) => set({ loanContracts: value }),
  setInterCompanyFinanceState: (value) => set({ interCompanyFinances: value }),
  setCompanyTypeState: (value) => set({ companyTypes: value }),
  setChartelCapitalTransactionsState: (value) =>
    set({ chartelCapitalTransactions: value }),
  setAccountState: (value) => set({ accounts: value }),
  setMoneyFlowReasonState: (value) => set({ moneyFlowReasons: value }),
  setDocumentSetState: (value) => set({ documentSets: value }),
  logout: () =>
    set({
      auth: null,
      users: [],
      companies: [],
      banks: [],
      bankAccounts: [],
      indentures: [],
      paymentPlans: [],
      sources: [],
      rights: [],
      accessGroups: [],
      loanContracts: [],
      interCompanyFinances: [],
      companyTypes: [],
      chartelCapitalTransactions: [],
      accounts: [],
      moneyFlowReasons: [],
      documentSets: [],
    }),
}))
